import { render, staticRenderFns } from "./inputRecord.vue?vue&type=template&id=04007e3d&scoped=true"
import script from "./inputRecord.vue?vue&type=script&lang=js"
export * from "./inputRecord.vue?vue&type=script&lang=js"
import style0 from "./inputRecord.vue?vue&type=style&index=0&id=04007e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04007e3d",
  null
  
)

export default component.exports